function weatherCodeToText(code) {
  const map = {
    0: { text: "晴", icon: "☀️" },
    1: { text: "基本晴", icon: "🌤️" },
    2: { text: "少云", icon: "⛅" },
    3: { text: "阴", icon: "☁️" },
    45: { text: "有雾", icon: "🌫️" },
    48: { text: "浓雾", icon: "🌫️" },
    51: { text: "毛毛雨", icon: "🌦️" },
    53: { text: "小雨", icon: "🌦️" },
    55: { text: "中雨", icon: "🌧️" },
    61: { text: "小雨", icon: "🌧️" },
    63: { text: "中雨", icon: "🌧️" },
    65: { text: "大雨", icon: "🌧️" },
    71: { text: "小雪", icon: "🌨️" },
    73: { text: "中雪", icon: "🌨️" },
    75: { text: "大雪", icon: "❄️" },
    80: { text: "阵雨", icon: "🌦️" },
    81: { text: "较强阵雨", icon: "🌧️" },
    82: { text: "强阵雨", icon: "⛈️" },
    95: { text: "雷雨", icon: "⛈️" },
  };

  return map[code] || { text: "天气未知", icon: "🌤️" };
}

export async function fetchWeatherByCoords(latitude, longitude) {
  const url =
    `https://api.open-meteo.com/v1/forecast?latitude=${latitude}` +
    `&longitude=${longitude}&current=temperature_2m,weather_code&timezone=auto`;

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("weather request failed");
  }

  const data = await res.json();
  const current = data?.current || {};
  const weather = weatherCodeToText(current.weather_code);

  return {
    temperature: current.temperature_2m,
    text: weather.text,
    icon: weather.icon,
  };
}

export async function fetchParisWeatherFallback() {
  return fetchWeatherByCoords(48.8566, 2.3522);
}

export function getCurrentPositionSafe() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("geolocation not supported"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve(position.coords);
      },
      (err) => {
        reject(err);
      },
      {
        enableHighAccuracy: false,
        timeout: 6000,
        maximumAge: 10 * 60 * 1000,
      }
    );
  });
}

export async function loadWeatherInfo() {
  try {
    const coords = await getCurrentPositionSafe();
    const result = await fetchWeatherByCoords(coords.latitude, coords.longitude);
    return {
      ...result,
      source: "current-location",
    };
  } catch {
    const fallback = await fetchParisWeatherFallback();
    return {
      ...fallback,
      source: "paris-fallback",
    };
  }
}